export const server = 'clients';